<template>
  <transition
    :duration="ANIMATION_DURATION"
    appear
    @before-leave="onRemove"
  >
    <div
      v-if="isShownState"
      :class="classNames"
      :style="{
        height,
        padding: '8px',
        marginBottom: isShownState ? 0 : -this.height
      }"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
    >
      <div
        ref="box"
        style="pointer-events: all;"
      >
        <Alert
          :title="title"
          :bs="bs"
          :title-bs="titleBs"
          :click-dismiss="onRemove"
          :modifier="modifier"
          variant="global"
        >
          <slot />
        </Alert>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
  import { defineComponent, PropType } from 'vue'
  import Alert from '../Alert/Alert.vue'
  import { animationCls } from './animation'
  import { BeerStyleObj } from '../../../core'

  const ANIMATION_DURATION = 240

  interface ToastData {
    ANIMATION_DURATION: number
    isShownState: boolean
    closeTimer?: NodeJS.Timeout
    transCls?: string
    height: number | string
  }

  export default defineComponent({
    name: 'Toast',
    components: {
      Alert,
    },
    props: {
      title: {
        type: String as PropType<string>,
      },
      modifier: {
        type: String as PropType<string>,
      },
      titleBs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      duration: {
        type: Number as PropType<number>,
        default: 5,
      },
      onRemove: {
        type: Function,
        default: () => ({}),
      },
      isShown: Boolean,
    },
    data() {
      const data: ToastData = {
        ANIMATION_DURATION,
        isShownState: true,
        closeTimer: undefined,
        transCls: undefined,
        height: 0,
      }
      return data
    },
    computed: {
      classNames() {
        return animationCls
      },
    },
    watch: {
      isShown(value, oldV) {
        if (oldV !== value) {
          this.isShownState = value
        }
      },
    },
    created() {
      this.startCloseTimer()
    },
    beforeUnmount() {
      this.clearCloseTimer()
    },
    mounted() {
      const el = this.$refs.box as HTMLElement

      if (el) {
        this.height = `${el.getBoundingClientRect().height + 16}px`
      }
    },
    methods: {
      close() {
        this.clearCloseTimer()
        this.isShownState = false
      },
      startCloseTimer() {
        this.closeTimer = setTimeout(() => {
          this.close()
        }, this.duration * 1000)
      },
      clearCloseTimer() {
        if (this.closeTimer) {
          clearTimeout(this.closeTimer)
          this.closeTimer = undefined
        }
      },
      handleMouseEnter() {
        this.clearCloseTimer()
      },
      handleMouseLeave() {
        this.startCloseTimer()
      },
    },
  })
</script>
